const getDefaultState = () => {
    return {
        legacyContracts: []
    }
}


const state = getDefaultState()

const getters = {
    getLegacyContracts: (state) => state.legacyContracts,
};

const mutations = {
    resetLegacyContractsState: (state) => Object.assign(state, getDefaultState()),
    setLegacyContracts: (state, legacyContracts) => state.legacyContracts = legacyContracts,
};

const actions = {
     async fetchLegacyContracts ({commit, getters}, forceApiCall = false) {
        if (!getters.getLegacyContracts.length || forceApiCall) {
            await axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/legacy-contract',
                cancelToken: window.AuthorizationCancelSource.token,
            }).then(response => {
                commit('setLegacyContracts', response.data);
            });
        }
    },
    resetLegacyContractsStates: ({commit}) => {
        commit('setLegacyContracts', []);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
